<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">{{ $t("edit") }} {{ $t("page") }}</div>
      <router-link class="btn-blue" :to="{ name: 'CMS Pages' }"
        >{{ $t("pages") }} {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <!-- <div class="input-material"> -->
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <!-- <input
            id="category_name"
            name="category_name"
            v-validate="'required'"
            v-model="category_name"
            placeholder="."
            />-->
            <multiselect
              :options="websitePages"
              v-model="selectedPage"
              :searchable="true"
              label="page_name"
              track-by="page_name"
              placeholder="Page"
              :allowEmpty="false"
              :showLabels="false"
              v-b-tooltip.hover
              :title="$t('page_name')"
              disabled
              style="background: transparent"
            ></multiselect>
            <!-- <label>Category Name</label> -->
            <!-- </div> -->
            <!---Tooltip :title="$t('page_name')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedPage == null"
              >Please Select a Page</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <drop @drop="setTitle">
                <textarea
                  id="seo_meta_title"
                  name="seo_meta_title"
                  v-validate="'required'"
                  v-model="seo_obj.seo_meta_title"
                  placeholder="Meta Title"
                  v-b-tooltip.hover
                  :title="$t('seo_meta_title')"
                />
                <label>Meta Title</label>
              </drop>
            </div>
            <!--Tooltip :title="$t('seo_meta_title')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('seo_meta_title')">{{
              errors.first("seo_meta_title")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <drop @drop="setDescription">
                <textarea
                  id="seo_meta_description"
                  name="seo_meta_description"
                  v-validate="'required'"
                  v-model="seo_obj.seo_meta_description"
                  placeholder="Meta Description"
                  v-b-tooltip.hover
                  :title="$t('seo_meta_description')"
                />
                <label>Meta Description</label>
              </drop>
            </div>
            <!--Tooltip :title="$t('seo_meta_description')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('seo_meta_description')">{{
              errors.first("seo_meta_description")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material-textarea">
              <drop @drop="setKeywords">
                <textarea
                  id="seo_meta_keywords"
                  name="seo_meta_keywords"
                  v-validate="'required'"
                  v-model="seo_obj.seo_meta_keywords"
                  placeholder="Meta Keywords"
                  v-b-tooltip.hover
                  :title="$t('seo_meta_keywords')"
                />
                <label>Meta Keywords</label>
              </drop>
            </div>
            <!--Tooltip :title="$t('seo_meta_keywords')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('seo_meta_keywords')">{{
              errors.first("seo_meta_keywords")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="og_type"
                name="og_type"
                v-validate="'required'"
                v-model="seo_obj.og_type"
                v-b-tooltip.hover
                :title="$t('og_type')"
              />
              <label
                :class="
                  seo_obj.og_type && seo_obj.og_type.length > 0
                    ? 'shift-up'
                    : ''
                "
                >OG Type</label
              >
            </div>
            <!--Tooltip :title="$t('og_type')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('og_type')">{{
              errors.first("og_type")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="og_site"
                name="og_site"
                v-validate="'required'"
                v-model="seo_obj.og_site"
                v-b-tooltip.hover
                :title="$t('og_site')"
              />
              <label
                :class="
                  seo_obj.og_site && seo_obj.og_site.length > 0
                    ? 'shift-up'
                    : ''
                "
                >OG Site</label
              >
            </div>
            <!--Tooltip :title="$t('og_site')" /-->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('og_site')">{{
              errors.first("og_site")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-2">
          <div class="d-flex align-items-center">
            <!-- <label class="mb-0 mr-3">{{ $t('active') }}</label>
            <label class="ios-switch">
              <input
                type="checkbox"
                class="ios-checkbox"
                v-model="seo_obj.seo_meta_is_active"
                true-value="Y"
                false-value="N"
              />
              <span class="switch-slider"></span>
            </label> -->
          </div>
        </div>
        <!-- <div v-for="(key, keyIndex) in keys" :key="keyIndex" class>
          <drag :transfer-data="key" class="m-2">
            <h6 class="font-weight-normal">
              <b-badge
                pill
                variant="primary"
                class="py-1 font-weight-normal px-2"
                >{{ key }}</b-badge
              >
            </h6>
          </drag>
        </div> -->
      </div>

      <section class="mb-2 col-lg-12 col-xl-12 align-self-center">
        <div class="bn-tabs-nav">
          <button
            v-for="(content, contentIndex) in PageContent"
            :key="contentIndex"
            :class="['btn-tab-title ', { active: contentIndex == activeClass }]"
            @click.prevent.stop="onChangeTabHandler($event, contentIndex)"
          >
            <strong>
              <span :class="notempty[contentIndex] ? '' : 'text-danger'">{{
                content.langauge
              }}</span>
            </strong>
          </button>
          <span class="editBtn" v-if="PageContent.length > 0">
            <button
              class="btn btn-sm btn-primary"
              @click="
                isEdit = !isEdit;
                isEditHtml = false;
              "
            >
              <img
                v-if="!isEdit"
                src="@/assets/img/icons/edit-pen-white.svg"
                height="15"
                width="15"
                class="mr-1"
              />{{ isEdit ? "Save Page" : "Edit Text" }}
            </button>
            <button
              class="btn btn-sm btn-primary"
              @click="
                isEditHtml = !isEditHtml;
                isEdit = false;
              "
            >
              <img
                v-if="!isEditHtml"
                src="@/assets/img/icons/edit-pen-white.svg"
                height="15"
                width="15"
                class="mr-1"
              />{{ isEditHtml ? "Save HTML" : "Edit HTML" }}
            </button>
          </span>
        </div>
        <div class="bn-tabs-content">
          <div
            v-for="(content, contentIndex) in PageContent"
            :key="contentIndex"
          >
            <div v-if="contentIndex === activeClass">
              <div class="row">
                <div class="col-lg-12 align-self-center mb-4" v-if="isEdit">
                  <vue-editor
                    v-model="content.page_content"
                    useCustomImageHandler
                    @image-added="handleImageAdded"
                    @text-change="CheckEmptyContent(content, contentIndex)"
                    name="page"
                    id="page"
                  ></vue-editor>
                </div>
                <div
                  class="input-material-textarea mb-4"
                  v-else-if="isEditHtml && !isEdit"
                >
                  <textarea
                    id="htmlContent"
                    name="htmlContent"
                    v-model="content.page_content"
                    placeholder="Page Content"
                    class="htmlContent"
                  />
                </div>
                <div class="col-lg-12 align-self-center mb-4 ql-snow" v-else>
                  <div
                    class="ql-editor"
                    v-html="content.page_content"
                    v-if="content.page_content"
                  ></div>
                  <div
                    class="ql-editor text-center"
                    v-else
                    style="min-height:33px;"
                  >
                    No Content
                  </div>
                </div>

                <vue-editor style="display:none" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="text-center">
        <button @click.prevent.stop="editSeo" class="btn-blue">
          {{ $t("update") }}
        </button>
        <button @click.prevent.stop="onResetForm()" class="btn-black">
          {{ $t("reset") }}
        </button>
        <b-button
          class="btn-outline-grey"
          variant="default"
          to="/marketing/list-pages"
          >{{ $t("cancel") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import Vue from "vue";
import VueDragDrop from "vue-drag-drop";
import { VueEditor } from "vue2-editor";
import MovieService from "@/services/MovieService";
import { IMGBASEURL } from "@/config/index.js";

Vue.use(VueDragDrop);

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      IMGBASEURL: IMGBASEURL,
      websitePages: [],
      editCode: false,
      selectedPage: null,
      seo_obj: {
        seo_meta_id: null,
        seo_meta_title: "",
        seo_meta_description: "",
        seo_meta_keywords: "",
        seo_meta_is_active: "Y",
        og_type: "",
        og_site: ""
      },
      submitted: false,
      keys: ["@movie", "@cinema", "@language", "@genre"],
      PageContent: [],
      Languages: [],
      ContentLanguages: [],
      activeClass: 0,
      notempty: [false, false, false, false, false, false],
      editorSettings: {},
      category_is_active: true,
      isEdit: false,
      isEditHtml: false
    };
  },
  beforeMount() {
    // this.getContentLanguage();
  },
  mounted() {
    const { seo_id } = this.$route.params;
    if (seo_id) {
      this.getWebsitePages(seo_id);
      this.getPageContent(seo_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    CheckEmptyContent: function(Content, index) {
      if (Content.page_content) {
        this.notempty[index] = true;
      } else {
        this.notempty[index] = false;
      }
    },
    onChangeTabHandler: function(event, index) {
      this.activeClass = index;
    },
    getPageContent(page_id) {
      let content = [];
      let payload = {
        page_id: page_id
      };
      MarketingService.GetPageContent(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            console.log("data", data);
            content = data.Records;
          }
          if (data && data.status && data.meta_info.length > 0) {
            this.seo_obj = {
              seo_meta_id: data.meta_info[0].seo_meta_id,
              seo_meta_title: data.meta_info[0].seo_meta_title,
              seo_meta_description: data.meta_info[0].seo_meta_description,
              seo_meta_keywords: data.meta_info[0].seo_meta_keywords,
              seo_meta_is_active: data.meta_info[0].seo_meta_is_active,
              og_type: data.meta_info[0].og_type,
              og_site: data.meta_info[0].og_site
            };
          }
        })
        .catch(err => {
          console.log("err", err);
        })
        .finally(() => {
          this.getContentLanguage(content);
        });
    },
    getContentLanguage: function(Content) {
      MovieService.GetMovieContentLanguages()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.ContentLanguages.length > 0) {
              // this.ContentLanguages = _.sortBy(data.ContentLanguages, [
              //   "langauge"
              // ]);
              this.ContentLanguages = data.ContentLanguages;
            }
            console.log("this.ContentLanguages", this.ContentLanguages);
          } else {
            // Show Error:
            console.log("data.message :", data.message);
          }
          return;
        })
        .then(() => {
          this.makeLangContainers(Content);
        })
        .catch(error => {});
    },
    makeLangContainers: function(Content) {
      this.ContentLanguages.map((x, i) => {
        let Array1 = [];
        if (Content && Content.length > 0) {
          Array1 = Content.filter(y => {
            return y.lang_id == x.langaugeId;
          });
        }
        if (Array1.length > 0) {
          x["page_content"] = Array1[0].page_content;
          x["mpc_id"] = Array1[0].mpc_id;
          if (Array1[0].page_content) {
            this.notempty[i] = true;
          }
        } else {
          x["page_content"] = "";
        }
      });
      this.PageContent = this.ContentLanguages;
      console.log("this.PageContent", this.PageContent);
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);
      formData.append("imagePath", "Banner Image");

      MasterService.GlobalUploadImage(formData)
        .then(result => {
          let url = result.data.path.includes("http")
            ? result.data.path.replace(/([^:]\/)\/+/g, "$1")
            : result.data.path.startsWith("/S3") ||
              result.data.path.startsWith("S3")
            ? this.IMGBASEURL + result.data.path
            : result.data.imageBaseURL + result.data.path; // Get url from response
          console.log("result", result);
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
    },
    onResetForm: function() {
      this.selectedPage = null;
      (this.seo_obj.seo_meta_title = ""),
        (this.seo_obj.seo_meta_description = ""),
        (this.seo_obj.seo_meta_keywords = ""),
        (this.seo_obj.seo_meta_is_active = "Y"),
        (this.seo_obj.og_type = ""),
        (this.seo_obj.og_site = "");
      console.log("this.seo_obj.seo_meta_id :>> ", this.seo_obj.seo_meta_id);
    },
    getSeoData: function(seo_id) {
      MarketingService.GetPage({ seo_id: seo_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.seo_obj = {
              seo_meta_id: data.Records[0].seo_meta_id,
              seo_meta_title: data.Records[0].seo_meta_title,
              seo_meta_description: data.Records[0].seo_meta_description,
              seo_meta_keywords: data.Records[0].seo_meta_keywords,
              seo_meta_is_active: data.Records[0].seo_meta_is_active,
              og_type: data.Records[0].og_type,
              og_site: data.Records[0].og_site
            };
            console.log("this.seo_obj :>> ", this.seo_obj);
            this.getWebsitePages(data.Records[0].seo_id);
          } else {
            //   this.seo_list = []
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    setKeywords(event) {
      console.log("event :>> ", event);
      this.seo_obj.seo_meta_keywords += ` ${event}`;
    },
    setDescription(event) {
      console.log("event :>> ", event);
      this.seo_obj.seo_meta_description += ` ${event}`;
    },
    setTitle(event) {
      console.log("event :>> ", event);
      this.seo_obj.seo_meta_title += ` ${event}`;
    },
    getWebsitePages: function(seo_id) {
      let payload = {
        tableName: "ms_pages",
        page_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.websitePages = data.Records;
            this.websitePages.map(x => {
              if (x.seo_id == seo_id) this.selectedPage = x;
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    editSeo() {
      this.submitted = true;
      if (this.selectedPage) {
        this.$validator.validate().then(valid => {
          if (valid) {
            // let loader = this.$loading.show();

            // console.log("JSON.stringify :", JSON.stringify(finalObj));
            let payload = {
              page_id: this.selectedPage.seo_id,
              seo_obj: this.seo_obj,
              PageContent: this.PageContent
            };
            MarketingService.EditPage(payload)
              .then(response => {
                const { data } = response;
                // loader.hide();
                if (data && data.status) {
                  this.$toasted.show(data.message);

                  this.$router.push({
                    path: "/marketing/list-pages"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          } else {
            this.$toasted.show("Please enter all details");
          }
        });
      } else {
        this.$toasted.show("Please select a page");
      }
    }
  }
};
</script>
<style>
.editBtn {
  position: absolute;
  right: 0;
}

.htmlContent {
  min-height: 250px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PageComponents/editPage.vue